export default "__VITE_ASSET__BtlO99wR__"